import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { roleTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const updateRole: roleTypes.UpdateRole = ({ id, data }) => {
  return axios.put(`/roles/${id}`, { data });
};

type UseUpdateRoleOptions = {
  config?: MutationConfig<typeof updateRole>;
};

export function useUpdateRole({ config = {} }: UseUpdateRoleOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('update-role', 'Updating role...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['roles']);
      queryClient.invalidateQueries(['account-me']);
      toasts.loadingToast.success('update-role', 'Role updated successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('update-role', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: updateRole,
  });
}
